import config from '../../config';
import { HTTP } from  '../../http';
import moment from 'moment';

const pageSize = 25;
const devicesRentalChargesUri = config.apiEndpoints.deviceRentalChargesUri;
export function  bindChargeDateList(months) {
    let currentDate = new Date();
    let pastDate = moment(currentDate).subtract(months, 'M').toDate();
    let canAdd = true;
    let pastDateFormatted = moment(pastDate).format('MM-YYYY');
    let result = [{ id: pastDate, name: pastDateFormatted }];
    let dateToAdd = pastDate;
    while(canAdd) {
        dateToAdd = moment(dateToAdd).add(1, 'M').toDate();
        if(dateToAdd.getTime() == currentDate.getTime()) {
            canAdd = false;
        }
        result.push({id: moment(dateToAdd).format(), name: moment(dateToAdd).format('MM-YYYY')});
    }
    return result;
}
export function queryStringParams(request) {
    const chargeDate = request.chargeDate == '' ?  '' : `&chargeDate=${moment(request.chargeDate).format()}`;
    const sellerId = request.sellerId == null ? '' : `&sellerId=${request.sellerId}`;
    return `${sellerId}${chargeDate}`;
}

export default {
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(devicesRentalChargesUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findAll: (request) => {
        return new Promise((resolve, reject) => {
            request.pageSize = pageSize
            request.chargeDate = request.chargeDate == '' ?  '' : moment(request.chargeDate).format()
            HTTP.get(devicesRentalChargesUri.concat('search'),{ params: request}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findAllExport: (request) => {        
        return new Promise((resolve, reject) => {
            HTTP.get(`${devicesRentalChargesUri}search/export?${queryStringParams(request)}`,
            {
                responseType: 'blob'
            }
            )
            .then(response => {                
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url);               
            }, error => {
                reject(error);
            })
        });        
    },
    getChargeDateAvailableList: () => {        
        return bindChargeDateList(2);
    },
    getChargeDateList: () => {
        return bindChargeDateList(11);
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(devicesRentalChargesUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    charge: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.patch(devicesRentalChargesUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}